{
  "name": "tebitasks-frontend-angular-app",
  "version": "1.2.7",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration local",
    "start:dev": "ng serve --configuration dev",
    "start:test": "ng serve --configuration test",
    "build": "ng build",
    "build:prod": "ng build --configuration prod",
    "build:dev": "ng build --configuration dev",
    "build:test": "ng build --configuration test",
    "watch": "ng build --watch --configuration local",
    "test": "ng test",
    "typedoc": "npx typedoc",
    "lint": "npx eslint projects/tebitasks/src",
    "madge": "node madge",
    "check": "npx eslint projects/tebitasks/src && node madge"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.4",
    "@angular/cdk": "^19.0.3",
    "@angular/common": "^19.0.4",
    "@angular/compiler": "^19.0.4",
    "@angular/core": "^19.0.4",
    "@angular/forms": "^19.0.4",
    "@angular/material": "^19.0.3",
    "@angular/material-date-fns-adapter": "^19.2.18",
    "@angular/platform-browser": "^19.0.4",
    "@angular/platform-browser-dynamic": "^19.0.4",
    "@angular/router": "^19.0.4",
    "@corporate/ng-tebis-base-components": "^0.0.86",
    "angular-oauth2-oidc": "^19.0.0",
    "date-fns": "^4.1.0",
    "i18next": "^23.16.5",
    "jwt-decode": "^4.0.0",
    "material-file-icons": "^2.4.0",
    "ngx-editor": "^18.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.6",
    "@angular/cli": "^19.0.6",
    "@angular/compiler-cli": "^19.0.5",
    "@types/jasmine": "~5.1.0",
    "eslint": "^9.12.0",
    "eslint-config-prettier": "^9.1.0",
    "globals": "^15.11.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "madge": "^8.0.0",
    "typedoc": "^0.26.9",
    "typedoc-plugin-coverage": "^3.3.0",
    "typedoc-plugin-missing-exports": "^3.0.0",
    "typescript": "~5.5.2",
    "typescript-eslint": "^8.8.1"
  }
}
